import React, {Fragment, Component} from 'react';
import TrainingPhaseFormCard from './TrainingPhaseFormCard';
import {FormGroup, Input, Label} from "reactstrap";

class TrainingProgramAddPhase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        header: this.props.phase.header,
        forms: this.props.phase.forms,
        type: this.props.phase.type,
        weeks: this.props.phase.weeks,
        hours: this.props.phase.hours,
      },
      addAfterPhase: this.props.trainingProgram.plan[0],
      addAfterPhaseIndex: 0
    };
  }

  handleInput(event) {
    const {value} = event.target;
    this.setState({
      addAfterPhaseIndex: value,
      addAfterPhase: this.props.trainingProgram.plan[value]
    })
  }

  updatePhase(formData) {
    this.props.onUpdate({
      formData,
      addAfterPhase: this.isAddAfterPhaseAvailable? parseInt(this.state.addAfterPhaseIndex): null
    })
  }

  // Computed //

  get isAddAfterPhaseAvailable() {
    return this.props.trainingProgram.plan.length > 0 && this.props.trainingProgram.plan[0].type === 'orientation';
  }

  render() {
    return (
      <Fragment>
        {
          this.isAddAfterPhaseAvailable &&
          <form>
            <FormGroup>
              <Label for="addAfterPhase">Add after phase</Label>
              <Input
                id='addAfterPhase'
                name="afterPhase"
                onBlur={event => this.handleInput(event)}
                onChange={event => this.handleInput(event)}
                type="select"
                value={this.state.addAfterPhaseIndex}
              >
                {this.props.trainingProgram.plan.map((plan, index) => (
                  <option value={index} key={index}>{plan.header}</option>
                ))}
              </Input>
            </FormGroup>
          </form>
        }
        <TrainingPhaseFormCard
          initialValues={this.state.initialValues}
          onClose={() => this.props.onClose()}
          onSave={formData => this.updatePhase(formData)}
        />
      </Fragment>
    );
  }
}

export default TrainingProgramAddPhase;
